import styled from 'styled-components'
import { Text } from 'rebass'

export const TextYellowLightColor = styled(Text)`
　background-image:-webkit-linear-gradient(bottom,#FFD600,#FF7A00);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent; 
`
